import styled from 'styled-components';

export const SelectRadioBox = styled.div`
  position: absolute;
  background: #999;
  top: 0; bottom: 0;
  left: 0; right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  display: none;
`;
